import { chain } from "lodash";
import { useProducts } from "../../../adapters/uplist";
import { firstLastIndexOfRegex, isInternal } from "../../../helpers";
import { DIGITAL_BROCHURE_SIZE_SKU } from "../../../helpers/printConstants";
import { Select } from "../../fields";
import { NoTemplate } from "./NoTemplate";
import { usePrintTypeValues } from "./helpers";
export const DigitalTemplateSelect = (props) => {
  const { data: products } = useProducts();
  const { skus, required } = usePrintTypeValues("digital_brochure");

  if (!skus.length) return <NoTemplate />;
  const getProductSize = (sku) => {
    const name = products[sku]?.name;
    const [first, last] = firstLastIndexOfRegex(name, /\d/g);
    return name.slice(first, last + 1);
  };
  const agent_sizes = chain(skus).map(getProductSize).uniq().value();
  const options = chain(["8.5x14", "11x17", "12x18", "8.5x11"])
    .filter((s) => isInternal() || agent_sizes.includes(s))
    .map((s) => {
      let label = s;
      if (isInternal() && agent_sizes.includes(s)) {
        label = `${label} (Agent template on file)`;
      }

      return { value: `Size ${s}`, label: label };
    })
    .value();

  return (
    <Select
      sku={DIGITAL_BROCHURE_SIZE_SKU}
      label={false}
      isClearable
      options={options}
      internalRequired
      required={required}
      {...props}
    />
  );
};
